export class UserRole {
  public static ADMIN: String = 'HAAdmin';
  public static USER: String = 'HAUser';
  public static GLOBAL_USER: String = 'HAGlobalUser';
}
